module.exports = "#account select {\n  margin-top: 20px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/gsm/gsm.component.less
// module id = 502
// module chunks = 0